"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateModalStatusOnRefresh = exports.setupExperimentalStorage = exports.logComponentInfo = exports.handleInitialLoadedComponentsUpdate = exports.handleInitialCurrentComponentUpdate = exports.getCurrentStoragedData = void 0;
var _storageService = _interopRequireDefault(require("../../service/storage/storageService"));
var _logService = require("../../service/log/logService");
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var logComponentInfo = exports.logComponentInfo = function logComponentInfo(_ref) {
  var name = _ref.name,
    initDate = _ref.initDate,
    owner = _ref.owner,
    docLink = _ref.docLink;
  (0, _logService.logger)('log', "%c\n\nThe ".concat(name, " is a EXPERIMENTAL component!"), ['background-color:#FFF8E6; font-weight: bold; font-size: 16px', "\n\n- Experiment started on: ".concat(initDate), "\n\n- Owner: ".concat(owner.developer, " from ").concat(owner.team, "."), "\n\n- Documentation: \n".concat(docLink), "\n\n- Suport: \nIn case of any doubts, reach out ".concat(owner.developer, " or cozy team on cozy-dev space (https://chat.google.com/room/AAAAnm6Kw54?cls=7)\n\n\n")]);
};
var getCurrentStoragedData = exports.getCurrentStoragedData = function getCurrentStoragedData(key) {
  return JSON.parse(_storageService["default"].getItem(key));
};
var getLocationHref = function getLocationHref() {
  return typeof window !== 'undefined' ? window.location.href : '';
};
var setupInitialStorageState = function setupInitialStorageState(storageService, componentInfo) {
  var hasNo = function hasNo(key) {
    return !storageService.getItem(key);
  };
  if (hasNo(_constants.key.COMPONENTS)) {
    storageService.setItem(_constants.key.COMPONENTS, JSON.stringify([{
      name: componentInfo.name,
      closed: 'false',
      viewed: 'false',
      infos: componentInfo
    }]));
  }
  if (hasNo(_constants.key.STATUS_REFRESH)) {
    storageService.setItem(_constants.key.STATUS_REFRESH, false);
  }
  if (hasNo(_constants.key.URL)) {
    storageService.setItem(_constants.key.URL, getLocationHref());
  }
  if (hasNo(_constants.key.STATUS_OPEN)) {
    storageService.setItem(_constants.key.STATUS_OPEN, false);
  }
};
var setupExperimentalStorage = exports.setupExperimentalStorage = function setupExperimentalStorage(storageService, componentInfo) {
  if (typeof window !== 'undefined') {
    setupInitialStorageState(storageService, componentInfo);
    var currentStoragedComponentsInfo = getCurrentStoragedData(_constants.key.COMPONENTS);
    logComponentInfo(componentInfo);
    if (!currentStoragedComponentsInfo.some(function (_ref2) {
      var name = _ref2.name;
      return name === componentInfo.name;
    })) {
      var updatedComponentsInfo = [].concat(_toConsumableArray(currentStoragedComponentsInfo), [{
        infos: componentInfo,
        name: componentInfo.name,
        closed: 'false',
        viewed: 'false'
      }]);
      storageService.setItem(_constants.key.COMPONENTS, JSON.stringify(updatedComponentsInfo));
    }
  }
};
var handleInitialCurrentComponentUpdate = exports.handleInitialCurrentComponentUpdate = function handleInitialCurrentComponentUpdate(componentInfo) {
  if (typeof window !== 'undefined') {
    var currentStoragedComponentsInfo = getCurrentStoragedData(_constants.key.COMPONENTS);
    if (currentStoragedComponentsInfo.some(function (_ref3) {
      var name = _ref3.name,
        viewed = _ref3.viewed;
      return name === componentInfo.name && viewed === 'false';
    })) {
      var updatedComponentsInfo = currentStoragedComponentsInfo.map(function (currentComponentInfo) {
        return (currentComponentInfo === null || currentComponentInfo === void 0 ? void 0 : currentComponentInfo.name) === (componentInfo === null || componentInfo === void 0 ? void 0 : componentInfo.name) ? _objectSpread(_objectSpread({}, currentComponentInfo), {}, {
          viewed: 'true',
          closed: 'false'
        }) : currentComponentInfo;
      });
      _storageService["default"].setItem(_constants.key.COMPONENTS, JSON.stringify(updatedComponentsInfo));
      window.dispatchEvent(new Event('storage'));
    }
  }
};
var handleInitialLoadedComponentsUpdate = exports.handleInitialLoadedComponentsUpdate = function handleInitialLoadedComponentsUpdate(storageService) {
  var currentStoragedComponentsInfo = getCurrentStoragedData(_constants.key.COMPONENTS);
  var currentStoragedComponentsInfoToShow = currentStoragedComponentsInfo === null || currentStoragedComponentsInfo === void 0 ? void 0 : currentStoragedComponentsInfo.filter(function (_ref4) {
    var closed = _ref4.closed;
    return closed === 'false';
  });
  var hasRefreshedAndWasOpen = storageService.getItem(_constants.key.STATUS_REFRESH) === 'true' && storageService.getItem(_constants.key.STATUS_OPEN) === 'true' && currentStoragedComponentsInfo.some(function (_ref5) {
    var closed = _ref5.closed,
      viewed = _ref5.viewed;
    return viewed === 'true' && closed === 'false';
  });
  var hasPageURLChangedAndWasOpen = storageService.getItem(_constants.key.STATUS_OPEN) === 'true' && storageService.getItem(_constants.key.URL) !== getLocationHref() && currentStoragedComponentsInfo.some(function (_ref6) {
    var closed = _ref6.closed;
    return closed === 'false';
  });
  return {
    currentStoragedComponentsInfoToShow: currentStoragedComponentsInfoToShow,
    hasRefreshedAndWasOpen: hasRefreshedAndWasOpen,
    hasPageURLChangedAndWasOpen: hasPageURLChangedAndWasOpen
  };
};
var updateModalStatusOnRefresh = exports.updateModalStatusOnRefresh = function updateModalStatusOnRefresh(storageService) {
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', function () {
      if (storageService.getItem(_constants.key.STATUS_OPEN) === 'true') {
        storageService.setItem(_constants.key.STATUS_REFRESH, true);
      }
    });
  }
};